import React, { useEffect, useRef, useState } from "react";
import {
    Col,
    Container,
    Form,
    InputGroup,
    Nav,
    Overlay,
    Row,
    Tab,
    Table,
    Tooltip,
} from "react-bootstrap";
import closebtn from "../assets/images/close.svg";
import bigcalendar from "../assets/images/bigcalendarIcon.svg";
import activestatus from "../assets/images/activeStatus.svg";
import downloadAction from "../assets/images/download.svg";
import addIcon from "../assets/images/addSm.svg";
import inactivestatus from "../assets/images/inactivestatus.svg";
import minusIcon from "../assets/images/minusIcon.svg";
import network from "../assets/images/network.svg";
import searchicon from "../assets/images/searchicon.svg";
import visaicon from "../assets/images/visaicon.png";
import email from "../assets/images/email.svg";
import configuration from "../assets/images/configuration.svg";
import SemiCircleProgress from "./common-component/SemiCircleProgress";
import StackedBarChart from "./common-component/StackedBarChart";
import { Link, useNavigate } from "react-router-dom";
import LearnMorePopup from "./common-component/LearnMorePopup";
import DatePicker from "react-datepicker";
import BreadcrumbsNav from "./common-component/BreadcrumbsNav";
import Nodata from "./common-component/Nodata";
import {
    commonservices,
    CurrentYear,
    getCardBrandImage,
    getNormalisedBrandName,
} from "../services/CommonServices";
import {
    getCostwidgetdata,
    getMonthlycostbydataby,
} from "../services/ReduxTookit/Slice/ReportRedux";
import { useDispatch, useSelector } from "react-redux";
import Loader, { LoaderType } from "./common-component/Loader";
import moment from "moment";
import {
    ChargesByMachineMain,
    ChargesByWorkflow,
} from "../services/ReduxTookit/Slice/CostManagementRedux";
import ChargeByWorkflow from "../Modals/BillingCostModels/ChargeByWorkflow";
import { toContainHTML } from "@testing-library/jest-dom/matchers";
import ChargeByMachine from "../Modals/BillingCostModels/ChargeByMachine";
import InvoiceDataTable from "../Modals/BillingCostModels/InvoiceDataTable";
import arrowleft from "../assets/images/reshot-icon-arrow-left.svg";

import {
    AutoPayment,
    CreatePayment,
    PaymentMethodList,
} from "../services/ReduxTookit/Slice/InvoiceRedux";
import { toast } from "react-toastify";
import ChoosePaymentMethodModel from "../Modals/PaymentMethodModel/ChoosePaymentMethodModel";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Legend,
} from "chart.js";

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Legend
);

function BillingAndCostManagement() {
    const toUtcDayStartIso = (date) => {
        const value = new Date(date);
        if (Number.isNaN(value.getTime())) return "";
        return moment(value).format("YYYY-MM-DD");
    };

    const toUtcDayEndIso = (date) => {
        const value = new Date(date);
        if (Number.isNaN(value.getTime())) return "";
        return moment(value).format("YYYY-MM-DD");
    };

    const toUtcYearStartIso = (year) =>
        new Date(Date.UTC(Number(year), 0, 1, 0, 0, 0, 0)).toISOString();

    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let dispatch = useDispatch();
    let navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
    const [showPopup2, setShowPopup2] = useState(false);
    const [loading, setLoading] = useState(false);
    const ChargeByWorkflowData = useSelector(
        (state) =>
            state?.costmanagement?.ChargesByWorkflowData?.data?.data?.data?.dataList1
    );
    const today = new Date();
    const maxDate = new Date(today.getFullYear(), today.getMonth(), 1);
    const ChargeByMachineData = useSelector(
        (state) =>
            state?.costmanagement?.ChargesByMachineMainData?.data?.data?.data
                ?.dataList1
    );

    const handleshowPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowPopup(!showPopup);
    };
    const handleshowPopup2 = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowPopup2(!showPopup2);
    };
    const handleOverlay = (e) => {
        let element = document.getElementById(e?.currentTarget?.id);
        if (element) {
            if (element.classList.contains("overlay-isopen")) {
                element.classList.remove("overlay-isopen");
            } else {
                element.classList.add("overlay-isopen");
            }
        }
    };
    const target = useRef(null);
    const target1 = useRef(null);
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showCollapse, setShowCollapse] = useState(true);

    const handleShowCollapse = () => {
        setShowCollapse(!showCollapse);
    };
    const [showCollapse2, setShowCollapse2] = useState(true);

    const handleShowCollapse2 = () => {
        setShowCollapse2(!showCollapse2);
    };
    const [showCollapse3, setShowCollapse3] = useState(true);

    const handleShowCollapse3 = () => {
        setShowCollapse3(!showCollapse3);
    };
    const [startDate, setStartDate] = useState(
        moment().startOf("month").toDate()
    );

    const [endDate, setEndDate] = useState(moment().endOf("month").toDate());

    const handleDateChange = (date) => {
        if (!date) {
            setStartDate(null);
            setEndDate(null);
            return;
        }

        const start = moment(date).startOf("month").toDate(); // First day of selected month
        const end = moment(date).endOf("month").toDate(); // Last day of selected month

        setStartDate(start);
        setEndDate(end);
    };
    const BreadcrumbSingle = [
        {
            name: "Billing & Cost Management",
            link: "/billing-and-cost-maangement",
            active: true,
        },
    ];
    const [ChartReportLoader, setChartReportLoader] = useState(false);
    const [ChartReportHandle, setChartReportHandle] = useState({
        year: CurrentYear,
        databy: "workflow",
    });
    const [ChartReportData, setChartReportData] = useState({
        labels: [],
        datasets: [],
    });

    const [BillingDrilldownData, setBillingDrilldownData] = useState([]);

    const [IsShowDrilldownChart, setIsShowDrilldownChart] = useState(false);

    const [DrilldownChartReportData, setDrilldownChartReportData] = useState({
        labels: [],
        datasets: [],
        clickedLabel: "",
    });

    const [modalShowPaymentMethod, setModalShowPaymentMethod] = useState(false);
    const [CostwidgetList, setCostwidgetList] = useState([]);
    const [paymentReqObj, setPaymentReqObj] = useState(null);
    const [PaymentMethodData, setPaymentMethodData] = useState(null);
    const [paymentMethodList, setPaymentMethodList] = useState(null);
    const [PaymentLoading, setPaymentLoading] = useState(true);

    function fnHandleRadio(e) {
        const { checked, value } = e.target;
        if (checked) {
            setChartReportHandle({
                ...ChartReportHandle,
                ["databy"]: value,
            });
        }
    }
    const GetChargeByWorkflow = () => {
        setLoading(true);
        const body = {
            startdate: toUtcDayStartIso(startDate),
            enddate: toUtcDayEndIso(endDate),
            timezone: browserTimezone,
        };
        dispatch(ChargesByWorkflow(body))?.then(() => setLoading(false));
    };

    const GetChargeByMachine = () => {
        setLoading(true);
        const body = {
            startdate: toUtcDayStartIso(startDate),
            enddate: toUtcDayEndIso(endDate),
            timezone: browserTimezone,
        };
        dispatch(ChargesByMachineMain(body))?.then(() => setLoading(false));
    };

    const fnAutoPayment = async (item) => {
        try {
            const body = {
                amount: item.invoicefinalamount?.toFixed(2),
                paymentmethodid: paymentMethodList[0]?.paymentmethodid,
                associationid: item.invoiceid,
                associationtype: "Workflow Invoice"
            };
            const resp = await dispatch(AutoPayment(body));

            if (
                resp &&
                resp.payload &&
                resp.payload.isValidate &&
                resp.payload.data
            ) {
                if (resp.payload.data.status_code === 1) {
                    let tmpData = [...CostwidgetList];
                    tmpData?.forEach((element) => (element.status_term = "Paid"));
                    setCostwidgetList(tmpData);
                    toast.success(resp.payload.data.message);
                }
            } else {
                toast.error("Something went wrong.");
            }
        } catch (error) { }
    };

    const fnCreatePayment = async (item) => {
        try {
            const body = {
                amount: item.invoicefinalamount?.toFixed(2),
                invoiceno: item.invoiceno,
                returnurl:
                    window.location.origin + "/management-listing?from=bill&session_id={CHECKOUT_SESSION_ID}",
                associationid: item.invoiceid,
                associationtype: "Workflow Invoice",
            };
            const resp = await dispatch(CreatePayment(body));

            if (
                resp &&
                resp.payload &&
                resp.payload.isValidate &&
                resp.payload.data
            ) {
                if (resp.payload.data.status_code === 1 && resp.payload.data.data) {
                    window.location = resp.payload.data.data;
                }
            }
        } catch (error) { }
    };

    async function fngetCostwidgetdata() {
        let body = {
            currentmonthdate: new Date().toISOString(),
            workflowid: null,
            timezone: browserTimezone,
        };
        dispatch(getCostwidgetdata(body))
            .then((response) => {
                if (response?.payload?.isValidate) {
                    setCostwidgetList(response?.payload?.data?.data);
                }
                if (!response?.payload?.isValidate) {
                    setCostwidgetList([]);
                }
            })
    }

    async function fngetChartReport(selectedyear, databy) {
        setChartReportLoader(true);
        let body = {
            date: `${selectedyear}-01-01`,
            datagroupby: "month",
            databy: databy,
            workflowid: null,
            timezone: browserTimezone,
        };
        try {
            const response = await dispatch(getMonthlycostbydataby(body));
            if (response?.payload?.isValidate) {
                let templables = [];
                let tempdatasets = [];
                let dataByLabel = {};
                const data1 = response?.payload?.data?.data || [];
                setBillingDrilldownData(data1.dataList2)
                data1.dataList1.forEach((element) => {
                    templables.push(element.monthandyear);
                    if (!dataByLabel[element.displayname]) {
                        dataByLabel[element.displayname] = [];
                    }
                    dataByLabel[element.displayname].push({
                        monthandyear: element.monthandyear,
                        bill: element.bill,
                    });
                });
                templables = [...new Set(templables)];
                for (const [label, items] of Object.entries(dataByLabel)) {
                    if (label !== "") {
                        const dataset = {
                            label: label,
                            data: templables.map((month) => {
                                const item = items.find((i) => i.monthandyear === month);
                                return item ? item.bill : 0;
                            }),
                            backgroundColor: commonservices.CreateColor(label)?.BGColor,
                        };
                        tempdatasets.push(dataset);
                    }
                }
                setChartReportData({
                    labels: templables,
                    datasets: tempdatasets,
                });
            } else {
                setChartReportData({
                    labels: [],
                    datasets: [],
                });
            }
        } catch (error) {
        } finally {
            setChartReportLoader(false);
        }
    }

    useEffect(() => {
        fngetCostwidgetdata();
        GetChargeByWorkflow();
        GetChargeByMachine();
    }, [startDate, endDate]);

    useEffect(() => {
        fngetChartReport(ChartReportHandle?.year, ChartReportHandle?.databy);
    }, [ChartReportHandle]);

    function fnMonthtodatePercentage(monthtodate, forcasteofmonth) {
        if (monthtodate && forcasteofmonth) {
            let result = (monthtodate * 100) / forcasteofmonth;
            return commonservices.fnAmountDigitCount(result, 2);
        } else {
            return 0;
        }
    }
    function fnAveragegCostPercentage(avgofmonth, forcasteofmonth) {
        if (avgofmonth && forcasteofmonth) {
            let result = ((forcasteofmonth - avgofmonth) * 100) / forcasteofmonth;
            return commonservices.fnAmountDigitCount(result, 2);
        } else {
            return 0;
        }
    }

    const getPaymentMethodList = async () => {
        setPaymentLoading(true);
        const body = {};
        dispatch(PaymentMethodList(body))
            .then((response) => {
                if (response?.payload?.isValidate) {
                    setPaymentMethodList(response?.payload?.data?.data)
                    let filteredPaymentMethods = response?.payload?.data?.data?.filter(
                        (item) => item?.isprimary
                    );
                    setPaymentMethodData(filteredPaymentMethods[0]);
                }
                if (!response?.payload?.isValidate) {
                    setPaymentMethodList(null);
                    setPaymentMethodData(null);
                }
            })
            .finally(() => {
                setPaymentLoading(false);
            });
    };

    useEffect(() => {
        getPaymentMethodList();
    }, []);

    const [showAll, setShowAll] = useState(false);


    const Billing_options = {
        responsive: true,
        maintainAspectRatio: false,
        onClick: (event, elements) => {
            if (elements && elements.length > 0) {
                const element = elements[0];
                const index = element.index;
                const clickedLabel = ChartReportData.labels[index];

                if (BillingDrilldownData && BillingDrilldownData.length > 0) {
                    let templables = [];
                    let tempdatasets = [];
                    let dataByLabel = {};

                    let FilterData = BillingDrilldownData.filter((d) => d.monthandyear === clickedLabel);

                    if (FilterData && FilterData.length > 0) {
                        FilterData.forEach((element) => {
                            templables.push(element.days);
                            let displayname = element.displayname ? element.displayname : "-";
                            if (!dataByLabel[displayname]) {
                                dataByLabel[displayname] = [];
                            }
                            dataByLabel[displayname].push({
                                days: element.days,
                                bill: element.bill ? element.bill : 0,
                            });
                        });
                        templables = [...new Set(templables)];
                        for (const [label, items] of Object.entries(dataByLabel)) {
                            if (label !== "") {
                                const dataset = {
                                    label: label,
                                    data: templables.map((days) => {
                                        const item = items.find((i) => i.days === days);
                                        return item ? item.bill : 0;
                                    }),
                                    backgroundColor: commonservices.CreateColor(label)?.BGColor,
                                };
                                tempdatasets.push(dataset);
                            }
                        }
                        setDrilldownChartReportData({
                            labels: templables,
                            datasets: tempdatasets,
                            clickedLabel: clickedLabel,
                        });
                        setIsShowDrilldownChart(true);
                    }
                }
            }
        },
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    boxWidth: 12,
                    boxHeight: 12,

                    filter: (legendItem, chartData) => {
                        if (!showAll) {
                            if (legendItem.datasetIndex <= 4) {
                                return true;
                            }
                            return legendItem.text === "Show More...";
                        }
                        return true;
                    },
                    generateLabels: (chart) => {
                        const datasets = chart.data.datasets;

                        const defaultLabels = datasets.map((dataset, index) => ({
                            text: dataset.label,
                            fillStyle: dataset.backgroundColor,
                            hidden: !chart.isDatasetVisible(index),
                            datasetIndex: index,
                        }));

                        defaultLabels.push({
                            text: showAll ? "Show Less..." : "Show More...",
                            fillStyle: "#999",
                            strokeStyle: "#999",
                            lineWidth: 0,
                            datasetIndex: -1,
                        });
                        return defaultLabels;
                    },
                },
                onClick: (e, legendItem, legend) => {
                    if (
                        legendItem.text === "Show More..." ||
                        legendItem.text === "Show Less..."
                    ) {
                        setShowAll((prev) => !prev);
                        return;
                    }
                    ChartJS.defaults.plugins.legend.onClick.call(
                        this,
                        e,
                        legendItem,
                        legend
                    );
                },
            },
            tooltip: {
                mode: "index",
                intersect: false,

                callbacks: {
                    title: (tooltipItems) => tooltipItems[0].label,

                    label: (tooltipItem) => {
                        const value = tooltipItem.raw;

                        if (!value || value <= 0) return null;

                        return `${tooltipItem.dataset.label}: $${value}`;
                    },

                    footer: (tooltipItems) => {
                        const total = tooltipItems
                            .map(item => item.raw || 0)
                            .reduce((sum, val) => sum + val, 0);

                        return total > 0 ? `Total: $${total}` : null;
                    },
                },
            },
        },
        barThickness: 40,
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                },
            },
            y: {
                stacked: true,
                beginAtZero: true,
                ticks: {
                    callback: (value) => `$${value}`,
                },
                grid: {
                    display: true,
                    color: "#F1F1F1",
                },
            },
        },
    };

    return (
        <div className="BillingAndCostManagement-page-main having-small-blue-bg  all-page-top ">
            <Container>
                <div className="top-bot-section flex-column align-items-start gap-3">
                    <div className="position-relative z-2">
                        <BreadcrumbsNav pageNav={BreadcrumbSingle} />
                    </div>
                </div>
            </Container>
            <div className="main-page-content">
                <Container>
                    <div className="full-height-table w-100 bcmtop-main-wrapper">
                        <Row>
                            <Col xl={3}>
                                <div className="common-white-bg bcmtop-main">
                                    <h2>Cost Monitor</h2>
                                    <div>
                                        <div className="bcmtop-single">
                                            <h4>Budget Status</h4>
                                            <p>
                                                <Link to="#" className="theme-color-text fw600">
                                                    Setup Required
                                                </Link>
                                            </p>
                                            <h6>No Budget Created</h6>
                                        </div>
                                        <div className="bcmtop-single">
                                            <h4>Cost Anomalies Status (MTD)</h4>
                                            <p>
                                                <Link to="#" className="theme-color-text fw600">
                                                    Setup Required
                                                </Link>
                                            </p>
                                            <h6>No Monitor Created</h6>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col xl={3}>
                                <div className="common-white-bg bcmtop-main payment-method">
                                    <div className="payment-method-title">
                                        <h2>Payment Method</h2>
                                        <p
                                            className="cursor-pointer"
                                            onClick={() => {
                                                navigate(`/management-listing?pm=pm`);
                                            }}
                                        >
                                            Manage
                                        </p>
                                    </div>
                                    {/* <div className="d-flex justify-content-sm-center"> 
                      </div> */}
                                    {PaymentLoading ? (
                                        <Row>
                                            <Loader
                                                type={LoaderType.PaymentMethodSingleCard}
                                                count={1}
                                            />
                                        </Row>
                                    ) : (
                                        <>
                                            {PaymentMethodData ? (
                                                <div className="payment-method-detail">
                                                    <div className="payment-method-detail-img">
                                                        {/* <img src={visaicon} alt="visaicon" /> */}
                                                        {PaymentMethodData?.display_brand &&
                                                            getCardBrandImage(
                                                                PaymentMethodData?.display_brand
                                                            )}
                                                    </div>

                                                    <div className="payment-method-detail-data">
                                                        <div className="visa-title ">
                                                            <h4>
                                                                {/* {PaymentMethodData?.display_brand?.length &&
                                PaymentMethodData?.display_brand
                                  ?.charAt(0)
                                  ?.toUpperCase() +
                                  PaymentMethodData?.display_brand?.slice(
                                    1
                                  )}{" "} */}
                                                                {getNormalisedBrandName(
                                                                    PaymentMethodData?.display_brand
                                                                )}{" "}
                                                                Ending with {PaymentMethodData?.methodnumber}
                                                            </h4>
                                                            <span className="cursor-pointer bg-success text-white">
                                                                <b>Primary</b>
                                                            </span>
                                                            {/* <span>
                          <b>Default</b>
                        </span> */}
                                                        </div>
                                                        <p>
                                                            Expires{" "}
                                                            {`${PaymentMethodData?.exp_month
                                                                }/${PaymentMethodData?.exp_year?.substr(
                                                                    PaymentMethodData?.exp_year?.length - 2,
                                                                    PaymentMethodData?.exp_year?.length
                                                                )}`}
                                                        </p>
                                                        {/* <a href="mailto:john.wilson@gmail.com">
                        <span>
                          <img src={email} alt="email" />
                        </span>
                        <span>john.wilson@gmail.com</span>
                      </a> */}
                                                    </div>
                                                </div>
                                            ) : (
                                                <small>Payment method not available.</small>
                                            )}
                                        </>
                                    )}
                                    {/* <div className="bcmtop-inner-wrapper">
                    <div className="bcmtop-inner-single">
                      <h4>Getting Started</h4>
                      <p>
                        Create a cost anomaly monitor to automatically detect
                        cost anomailes.
                      </p>
                      <h6>Create A Monitor</h6>
                      <img src={bigcalendar} alt="close" />
                    </div>
                  </div> */}
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="BillingAndCostManagement-cost-summary">
                                    <h2 className="mb12">Cost Summary</h2>
                                    <div className="BillingAndCostManagement-cost-summary-wrapper-main">
                                        <div className="BillingAndCostManagement-cost-summary-wrapper w-100">
                                            <div className="BillingAndCostManagement-cost-summary-single">
                                                <div>
                                                    <h1>
                                                        $
                                                        {CostwidgetList?.[0]?.monthtodate
                                                            ? commonservices.fnAmountDigitCount(
                                                                CostwidgetList?.[0]?.monthtodate,
                                                                3
                                                            )
                                                            : 0}
                                                    </h1>
                                                    <p>
                                                        Month To <br />
                                                        Date
                                                    </p>
                                                </div>
                                                <div className="meter-chart">
                                                    <SemiCircleProgress
                                                        percentage={fnMonthtodatePercentage(
                                                            CostwidgetList?.[0]?.monthtodate,
                                                            CostwidgetList?.[0]?.lastmonthtodate
                                                        )}
                                                        chartTag="from last month for same period"
                                                    />
                                                </div>
                                            </div>
                                            <div className="BillingAndCostManagement-cost-summary-single">
                                                <div>
                                                    <h1>
                                                        $
                                                        {CostwidgetList?.[0]?.lastmonthtodate
                                                            ? commonservices.fnAmountDigitCount(
                                                                CostwidgetList?.[0]?.lastmonthtodate,
                                                                3
                                                            )
                                                            : 0}
                                                    </h1>
                                                    <p>
                                                        Last Month Cost For
                                                        <br /> The Same Time Period
                                                    </p>
                                                </div>
                                                <div className="meter-chart">
                                                    <SemiCircleProgress
                                                        // percentage={60}
                                                        percentage={fnMonthtodatePercentage(
                                                            CostwidgetList?.[0]?.lastmonthtodate,
                                                            CostwidgetList?.[0]?.lastmonth
                                                        )}
                                                        chartTag="from last month's total cost"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="BillingAndCostManagement-cost-summary-wrapper w-100">
                                            <div className="BillingAndCostManagement-cost-summary-single w-100">
                                                <div className="w-100">
                                                    <div className="d-flex align-items-start w-100 justify-content-between">
                                                        <h1>
                                                            $
                                                            {CostwidgetList?.[0]?.lastmonth
                                                                ? commonservices.fnAmountDigitCount(
                                                                    CostwidgetList?.[0]?.lastmonth,
                                                                    3
                                                                )
                                                                : 0}
                                                        </h1>
                                                        {CostwidgetList[0]?.status_term?.toUpperCase() === "UNPAID" ? (
                                                            <button
                                                                className="blue-btn w-auto btn-sm"
                                                                style={{ height: "fit-content", }}
                                                                //   onClick={() => fnCreatePayment(CostwidgetList[0])}
                                                                onClick={() => {
                                                                    if (paymentMethodList?.length === 1) {
                                                                        fnAutoPayment(CostwidgetList[0])
                                                                    } else if (paymentMethodList?.length > 1) {
                                                                        let reqObj = {
                                                                            amount: CostwidgetList[0]?.invoicefinalamount?.toFixed(2),
                                                                            associationid: CostwidgetList[0]?.invoiceid,
                                                                        };
                                                                        setPaymentReqObj({ reqObj })
                                                                        setModalShowPaymentMethod(true)
                                                                    } else {
                                                                        fnCreatePayment(CostwidgetList[0])
                                                                    }
                                                                }}
                                                            >
                                                                Pay Now
                                                            </button>
                                                        ) : (
                                                            <span className="span-paid-label">PAID</span>
                                                        )}
                                                    </div>
                                                    <p>
                                                        Last Month's <br />
                                                        Total Cost
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="BillingAndCostManagement-cost-summary-single">
                                                <div>
                                                    <h1>
                                                        $
                                                        {CostwidgetList?.[0]?.forcasteofmonth
                                                            ? commonservices.fnAmountDigitCount(
                                                                CostwidgetList?.[0]?.forcasteofmonth,
                                                                3
                                                            )
                                                            : 0}
                                                    </h1>
                                                    <p>
                                                        Total Forecasted Cost
                                                        <br /> For Current Month
                                                    </p>
                                                </div>
                                                <div className="BillingAndCostManagement-cost-summary-single-calendar">
                                                    <img src={bigcalendar} alt="bigcalendar" />
                                                    {/* <span>12/12/23</span> */}
                                                    <span>
                                                        {commonservices.getDateInFormatCustom(
                                                            new Date(),
                                                            null,
                                                            "MM/DD/yyyy"
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col xl={9} className="xl-pr20 mt20">
                                {
                                    !IsShowDrilldownChart ?
                                        <div className="dashboard-stacked-chart common-white-bg">
                                            <div className="chart-title">
                                                <div className="d-flex align-items-center gap-3">
                                                    <h5>Billing By Month</h5>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <Form.Check
                                                            type="radio"
                                                            id="workflow"
                                                            label="Workflow"
                                                            name="workflow"
                                                            value="workflow"
                                                            checked={ChartReportHandle.databy === "workflow"}
                                                            onChange={(e) => fnHandleRadio(e)}
                                                        />
                                                        <Form.Check
                                                            type="radio"
                                                            id="machine"
                                                            label="Machine"
                                                            name="machine"
                                                            value="machine"
                                                            checked={ChartReportHandle.databy === "machine"}
                                                            onChange={(e) => fnHandleRadio(e)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {ChartReportLoader ? (
                                                <div className="my-2">
                                                    <Loader type={LoaderType.ChartLine} />
                                                </div>
                                            ) : (
                                                <div className="dashboard-stacked-chart-main-chart-wrapper">
                                                    {ChartReportData?.datasets?.length > 0 ? (
                                                        <Bar data={ChartReportData} options={Billing_options} />
                                                    ) : (
                                                        <div className="d-flex h-100 justify-content-center align-items-center">
                                                            <Nodata />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        :
                                        <div className="dashboard-stacked-chart common-white-bg">
                                            <div className="chart-title">
                                                <div className="d-flex align-items-center gap-3">
                                                    <h5>Billing By Date</h5>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    <img src={arrowleft} alt="listicon" className="cursor-pointer" onClick={(e) => setIsShowDrilldownChart(false)} />
                                                </div>
                                            </div>
                                            <div className="dashboard-stacked-chart-main-chart-wrapper">
                                                <StackedBarChart data={DrilldownChartReportData} />
                                            </div>
                                        </div>
                                }
                            </Col>
                            <Col xl={3} className="mt20 xl-ps-0">
                                <div className="common-white-bg aside-of-graph mb20">
                                    <div>
                                        <h5>
                                            Cost Allocation
                                            <br /> Coverage
                                        </h5>
                                        <p>
                                            You haven’t created any cost allocation tags or cost
                                            categories...
                                            <span
                                                className="theme-color-text fw600 cursor-pointer"
                                                id="learn-more"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleOverlay(e);
                                                    setShow(!show);
                                                    handleshowPopup();
                                                }}
                                                ref={target}
                                            >
                                                Learn More
                                            </span>
                                        </p>
                                    </div>
                                    <img src={network} alt="network" />
                                </div>
                                <div className="common-white-bg aside-of-graph">
                                    <div>
                                        <h5>
                                            Saving
                                            <br /> Opportunities
                                        </h5>
                                        <p>
                                            Enable cost optimization hub to start receiving saving
                                            recomme...
                                            <span
                                                className="theme-color-text fw600 cursor-pointer"
                                                id="learn-more2"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleOverlay(e);
                                                    setShow2(!show2);
                                                    handleshowPopup2();
                                                }}
                                                ref={target1}
                                            >
                                                Learn More
                                            </span>
                                        </p>
                                    </div>
                                    <img src={configuration} alt="configuration" />
                                </div>
                            </Col>
                            <Col xl={12} className="mt20 mb-3">
                                <div className="common-white-bg service-charges-tabing billing-charges">
                                    <Tab.Container
                                        id="left-tabs-example"
                                        defaultActiveKey="first"
                                        className="underlined-tabing"
                                    >
                                        <div className="service-charges-tabing-inner">
                                            <div className="popup-title  p-0">
                                                <Nav variant="pills" className="flex">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="first">
                                                            Charges by Workflow
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="second">
                                                            Charges by Machines
                                                        </Nav.Link>
                                                    </Nav.Item>

                                                    <Nav.Item>
                                                        <Nav.Link eventKey="third">Invoices</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                                <div Col xl={3}>
                                                    <DatePicker
                                                        selected={startDate}
                                                        onChange={handleDateChange}
                                                        dateFormat="MMMM yyyy"
                                                        showMonthYearPicker
                                                        placeholderText="Select month"
                                                        isClearable
                                                        maxDate={maxDate}
                                                    />
                                                </div>
                                            </div>

                                            <Tab.Content className="pb-0">
                                                <Tab.Pane eventKey="first">
                                                    <div className="tab-top-section">
                                                        <div className="tab-top-section-single">
                                                            <p>Total Active Workflows</p>
                                                            <h4>{ChargeByWorkflowData?.length || 0}</h4>
                                                        </div>
                                                        <div className="tab-top-section-single">
                                                            <p>Total pre-tax service charges in USD</p>
                                                            <h4>
                                                                $
                                                                {commonservices.fnAmountDigitCount(
                                                                    ChargeByWorkflowData?.reduce(
                                                                        (total, items) =>
                                                                            total +
                                                                            (parseFloat(items?.consumptioncost) || 0),
                                                                        0
                                                                    ),
                                                                    5
                                                                )}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <ChargeByWorkflow
                                                        data={ChargeByWorkflowData}
                                                        startDate={startDate}
                                                        endDate={endDate}
                                                        mainLoading={loading}
                                                    />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="second">
                                                    <div className="tab-top-section">
                                                        <div className="tab-top-section-single">
                                                            <p>Total Active Machines</p>
                                                            <h4>{ChargeByMachineData?.length || 0}</h4>
                                                        </div>
                                                        <div className="tab-top-section-single">
                                                            <p>Total pre-tax service charges in USD</p>
                                                            <h4>
                                                                ${" "}
                                                                {commonservices.fnAmountDigitCount(
                                                                    ChargeByMachineData?.reduce(
                                                                        (total, items) =>
                                                                            total +
                                                                            (parseFloat(items?.consumptioncost) || 0),
                                                                        0
                                                                    ),
                                                                    5
                                                                )}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <ChargeByMachine
                                                        data={ChargeByMachineData}
                                                        startDate={startDate}
                                                        endDate={endDate}
                                                        mainLoading={loading}
                                                    />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="third">
                                                    <InvoiceDataTable
                                                        startDate={startDate}
                                                        endDate={endDate}
                                                    />
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </div>
                                    </Tab.Container>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
            {showPopup && (
                <Overlay target={target.current} show={showPopup} placement="left">
                    {(props) => (
                        <Tooltip id="overlay-example" {...props}>
                            <LearnMorePopup
                                handleshowPopup={handleshowPopup}
                                title="Cost Allocation Coverage"
                            />
                        </Tooltip>
                    )}
                </Overlay>
            )}
            {showPopup2 && (
                <Overlay target={target1.current} show={showPopup2} placement="left">
                    {(props) => (
                        <Tooltip id="overlay-example" {...props}>
                            <LearnMorePopup
                                handleshowPopup={handleshowPopup2}
                                title="Saving Opportunities"
                            />
                        </Tooltip>
                    )}
                </Overlay>
            )}
            {modalShowPaymentMethod && (
                <ChoosePaymentMethodModel
                    CostwidgetList={CostwidgetList}
                    setCostwidgetList={setCostwidgetList}
                    requestObj={paymentReqObj}
                    paymentMethodList={paymentMethodList}
                    show={modalShowPaymentMethod}
                    onHide={() => setModalShowPaymentMethod(false)}
                />
            )}
        </div>
    );
}

export default BillingAndCostManagement;
